if (!customElements.get('shade-quiz')) {
  customElements.define('shade-quiz', class extends HTMLElement {
    constructor() {
      super();
      this.scrollToTop();
      this.products = JSON.parse(this.querySelector('script[data-quiz-products]').innerText);
      this.questions = document.querySelectorAll('[data-question]');
      this.buttons = document.querySelectorAll('button[data-answer]');
      this.filteredProducts = this.products.reverse();

      this.recommendedProductElement = document.querySelector('[data-recommended-block]');
      this.recommendedProductElementBlankSlate = this.recommendedProductElement.innerHTML;
      this.recommendedProductElementAlternate = document.querySelector('[data-recommended-block-alternate]');
      this.recommendedProductElementAlternateBlankSlate = this.recommendedProductElementAlternate.innerHTML;

      this.recommendedProductElementSecondary = document.querySelector('[data-recommended-secondary-block]');
      this.recommendedProductElementSecondaryBlankSlate = this.recommendedProductElementSecondary.innerHTML;
      this.recommendedProductElementSecondaryAlternate = document.querySelector('[data-recommended-secondary-block-alternate]');
      this.recommendedProductElementSecondaryAlternateBlankSlate = this.recommendedProductElementSecondaryAlternate.innerHTML;

      this.blocks = this.querySelectorAll('.shade-quiz-block');
      this.querySelector('#quiz-reset').addEventListener('click', this.resetQuiz.bind(this));
      this.previousButton = this.querySelector('button[data-prev]');
      this.nextButton = this.querySelector('button[data-next]');
      this.startButton = this.querySelector('#start-quiz')
      this.currentBlock = 0;
      this.quizId = this.getAttribute('data-quiz-id');
      this.loggedIn = this.quizId ? true : false;
      this.emailFormEnabled = this.querySelector('#shade-quiz-recommended-block') ? true : false;
      console.log(this.filteredProducts);
    }

    connectedCallback() {
      window.addEventListener('beforeunload', () => {
        this.shadeQuizCompleteEvent(true)
        // If you want to display a custom message to the user when they navigate away:
        // event.returnValue = '';
      });

      this.previousButton.addEventListener('click', () => {
        this.showBlock('prev');
        this.scrollToTop();
        // TODO: Set quiz to this block state
        // this.hideAnswers();
      });
      this.nextButton.addEventListener('click', () => {
        this.showBlock()
        this.scrollToTop();
        this.nextButton.style.display = 'none';
        // this.hideAnswers();
      });
      if(this.startButton){
        this.startButton.addEventListener('click', () => {
          // this.resetQuiz();
          this.showBlock()
          this.scrollToTop();
          // this.hideAnswers();
        });
      }
    if(this.emailFormEnabled){
      this.querySelector('#shade-recommended-email__skip')?.addEventListener('click', (event) => {
        event.preventDefault();
        this.showBlock();
      });

      const form = document.querySelector('#shade-recommended-email');
      const button = document.querySelector('#shade-recommended-submit');

      if (button && form.dataset.formId) {
        button.addEventListener('click', (e) => {
          e.preventDefault(); // Prevent form submission
          let email = form.querySelector('input[type="email"]').value;
          if(email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            fetch("https://a.klaviyo.com/client/events/?company_id=TkRNkf", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "revision": "2025-01-15",
              },
              body: JSON.stringify({
                data: {
                  type: "event",
                  attributes: {
                    profile: {
                      data: {
                        type: "profile",
                        attributes: {
                          email,
                        },
                      },
                    },
                    metric: {
                      data: {
                        type: "metric",
                        attributes: {
                          name: "Submitted Quiz",
                        },
                      },
                    },
                    properties: {
                      primary_shade_result: this.filteredProducts[0].product.variant.title ?? this.filteredProducts[0].product.title,
                      secondary_shade_result: this.filteredProducts[0].productAlternate.variant.title ?? this.filteredProducts[0].productAlternate.title,
                      primary_shade_description: this.filteredProducts[0].product.variant.description ?? this.filteredProducts[0].product.description,
                      secondary_shade_description: this.filteredProducts[0].productAlternate.variant.description ?? this.filteredProducts[0].productAlternate.description,
                      form_id: form.dataset.formId,
                    },
                  },
                },
              }),
            }).then(response => {
              if (response.ok) {
                return response.json();
              }
              throw new Error('Network response was not ok.');
            }).then(data => {
              console.log(data);
            }).catch(error => {
              console.error('There has been a problem with your fetch operation:', error);
            });
            this.showBlock()
          }
        })
      }
    }
      // QUIZ LOGIC
      this.questions.forEach(question => {
        question.addEventListener('click', event => {
          let currentButton = event.target.closest('button[data-answer]');
          if (currentButton) {
            currentButton.classList.toggle('selected');
            const selected = question.querySelectorAll('button.selected')
            if(selected.length < parseInt(question.dataset.answerNumber)){
              this.nextButton.style.display = 'block';
              return
            }
            const answer = currentButton.getAttribute('data-answer');
            question.setAttribute('data-selected', answer);
            if(question.dataset.functional === 'true') {
              this.filteredProducts = this.getAnswer(answer, question);
            }
            this.hideAnswers();
          }
        });
      });
    }

    showBlock(direction){
      this.scrollToTop();
      this.blocks[this.currentBlock].style.display = 'none';
      direction === 'prev' ? this.currentBlock-- : this.currentBlock++;
      this.blocks[this.currentBlock].style.display = 'flex';
      if (this.blocks[this.currentBlock].dataset.recommendation === 'true') {
        if(this.recommendedProductElement){
          if(this.filteredProducts[0].product.variant){
            this.updateForm(this.recommendedProductElement, this.filteredProducts[0].product.variant, this.filteredProducts[0].product)
          }
          else {
            this.updateForm(this.recommendedProductElement, this.filteredProducts[0].product)
          }
        }
        if(this.recommendedProductElementAlternate){
          if(this.filteredProducts[0].productAlternate.variant){
            this.updateForm(this.recommendedProductElementAlternate, this.filteredProducts[0].productAlternate.variant, this.filteredProducts[0].productAlternate)
          }
          else {
            this.updateForm(this.recommendedProductElementAlternate, this.filteredProducts[0].productAlternate)
          }
        }

        // Secondary items
        if(this.recommendedProductElementSecondary){
          if(this.filteredProducts[0].secondary.variant){
            this.updateForm(this.recommendedProductElementSecondary, this.filteredProducts[0].secondary.variant, this.filteredProducts[0].secondary)
          }
          else {
            this.updateForm(this.recommendedProductElementSecondary, this.filteredProducts[0].secondary)
          }
        }
        if(this.recommendedProductElementSecondaryAlternate){
          if(this.filteredProducts[0].secondaryAlternate.variant){
            this.updateForm(this.recommendedProductElementSecondaryAlternate, this.filteredProducts[0].secondaryAlternate.variant, this.filteredProducts[0].secondaryAlternate)
          }
          else {
            this.updateForm(this.recommendedProductElementSecondaryAlternate, this.filteredProducts[0].secondaryAlternate)
          }
        }
        this.shadeQuizCompleteEvent()
      }
    }

    getAnswer(answer, question) {
      this.scrollToTop();
      let tempProducts = this.filteredProducts;
      question.querySelectorAll('button[data-answer].selected').forEach(button => {
        tempProducts = tempProducts.filter(product => {
          if (product.answers.includes(answer)) {
            return product;
          }
        })
      });
      return tempProducts
    }

    hideAnswers() {
      this.scrollToTop();
      // Combine all answers into a single array
      const allAnswers = this.filteredProducts.flatMap(product => product.answers);

      // Use a Set to remove duplicates and convert it back to an array
      const uniqueAnswers = [...new Set(allAnswers)];

      this.questions.forEach((question, index) => {
        if(question.dataset.functional === 'true') {
          question.querySelectorAll('button[data-answer]').forEach(button => {
            if (!uniqueAnswers.includes(button.getAttribute('data-answer'))) {
              button.parentElement.style.display = 'none';
            }
          });
        }
      })
      this.nextButton.style.display = 'none';
      this.blocks[this.currentBlock].style.display = 'none';
      this.currentBlock++
      this.blocks[this.currentBlock].style.display = 'flex';
    }

    updateForm(element, product, fullProduct = null) {
      this.scrollToTop();
      const button = element.querySelector('button');
      if(product.id){
        const isInStock = product.in_stock === 'true' || product.in_stock === true;
        const atcWrapper = element.querySelector('.vbb-call-to-action__button-wrapper');
        const signUpModal = element.querySelector('sign-up-modal');

        element.querySelector('vbb-multi-atc').dataset.variantIds = product.id;

        if(signUpModal) {
          atcWrapper?.style.setProperty('display', isInStock ? '' : 'none');
          signUpModal.style.display = isInStock ? 'none' : '';
          if(!isInStock) {
            const variantId = String(product.id);
            signUpModal.activeVariantId = variantId;
            if(signUpModal.modalOpenerButton) signUpModal.modalOpenerButton.dataset.variantId = variantId;
            signUpModal.updateModalTitle({ trackingInfo: { item_name: fullProduct?.title || product.title, item_variant: product.title } });
          }
          signUpModal.setVisible(!isInStock);
        } else {
          const btn = atcWrapper?.querySelector('button') || element.querySelector('button');
          if(btn) {
            btn.disabled = !isInStock;
            btn.innerText = isInStock ? window.variantStrings.addToCart : window.variantStrings.soldOut;
          }
        }
      }
      if(element.querySelector('.shade-quiz-product--title') && fullProduct) {
        element.querySelector('.shade-quiz-product--title').innerText = fullProduct.title;
      }
      if(element.querySelector('.shade-quiz-product--title__variant')) {
        element.querySelector('.shade-quiz-product--title__variant').innerText = product.title;
      }
      element.querySelector('p').innerText = product.description;
      if(product.image && element.querySelector('img')) {
        element.querySelector('img').src = product.image;
        element.querySelector('img').alt = `${product.title} recommended product image`;
      }
    }
    resetQuiz() {
      this.scrollToTop();
      this.buttons.forEach(button => {
        button.parentElement.style.display = 'block';
        button.classList.remove('selected');
        button.disabled = false;
        button.style.opacity = 1;
      });
      this.blocks[this.currentBlock].style.display = 'none';
      this.currentBlock = 0;
      this.blocks[this.currentBlock].style.display = 'flex';

      this.filteredProducts = this.products;

        // Reset the recommended product elements' inner HTML
      this.recommendedProductElement.innerHTML = this.recommendedProductElementBlankSlate;
      this.recommendedProductElementSecondary.innerHTML = this.recommendedProductElementSecondaryBlankSlate;
    }

    shadeQuizCompleteEvent(abandoned = false) {
      const answers = Array.from(this.questions).map(question => {
        return {
          question: question.dataset.question,
          answers: Array.from(question.querySelectorAll('button.selected')).map(button => button.getAttribute('data-answer'))
        };
      });

      const eventData = {
        uniqueUserId: this.getUniqueUserID(),
        questionData: answers,
        recommendedProduct: abandoned ? null : this.filteredProducts[0].product.variant.id,
        secondaryProduct: abandoned ? null : this.filteredProducts[0].secondary.variant.id,
        recommendedAlternate: this.filteredProducts[0].productAlternate.variant.title ?? this.filteredProducts[0].productAlternate.title,
        secondaryAlternate: this.filteredProducts[0].secondaryAlternate.variant.title ?? this.filteredProducts[0].secondaryAlternate.title,
        loggedIn: this.loggedIn
      }

      window.Shopify.analytics.publish(`shade_quiz_${abandoned ? 'abandoned' : 'completed'}`, eventData);

      console.log({
        'event': abandoned ? 'shade_quiz_abandoned' : 'shade_quiz_completed',
        eventData
      })
    }

    // DEV NOTE: Might be worth making this a global function
    getUniqueUserID() {
      // Check if we already have one in localStorage
      if(this.quizId){
        return this.quizId
      }

      this.uniqueUserId = localStorage.getItem('vbb-unique-user-id');

      if (this.uniqueUserId == null) {
        const uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );

        this.uniqueUserId = uuid;

        localStorage.setItem('vbb-unique-user-id', uuid);
      }

      return this.uniqueUserId
    }
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // This makes the scroll smooth
      });
    }
  });
}
